import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CopilotFacadeService } from 'src/app/services/copilot/copilot-facade.service';
import { SegmentService } from 'src/app/services/segment/segment.service';

@Component({
  selector: 'app-copilot-launcher',
  templateUrl: './copilot-launcher.component.html',
  styleUrls: ['./copilot-launcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopilotLauncherComponent {
  constructor(
    private readonly facade: CopilotFacadeService,
    private readonly segmentService: SegmentService,
  ) { }

  onClick(): void {
    this.trackClick();
    this.facade.toggle();
  }

  private trackClick(): void {
    const pageName = globalThis.document?.title ?? '';
    this.segmentService.trackInAppEvents(`${pageName} Events`, {
      name: 'Clicked On ASK AI',
      location: 'top nav',
      origin: pageName,
    });
  }
}
